import { axiosInstance } from 'shared/config/axios';
import { CreateApiKeyRequest, DeleteApiKeyRequest, GetApiKeysRequest } from 'entities/ApiKeys/api/types';

export const getApiKeys: GetApiKeysRequest = () => {
	return axiosInstance.get('/apiKeys');
};

export const createApiKey: CreateApiKeyRequest = (data) => {
	return axiosInstance.post('/apiKeys', data);
};

export const deleteApiKey: DeleteApiKeyRequest = (id) => {
	return axiosInstance.delete(`/apiKeys/${id}`);
};
